export default "__VITE_ASSET__BCUdLqMx__"